import { useEffect } from "react";
import UniBtn, { UniBtnPack } from "./UniBtn";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import { _zzyourmap_extract_editorjs_renderable_data } from "../utils/zz/zz-yourmap-blog-post-utils";
import { yourmapNavMaker, _zzyourmap_routing_browser_title_update, _zzyourmap_routing_routeState_to_path, _zzyourmap_routing_static_pages_keys, _zzyourmap_routing_tab_keys } from "../utils/zz/zz-yourmap-routing";
import { _zzyourmap_config } from "../utils/zz/zz-yourmap-config";
import { rapidozi_contact_utils } from "../utils/frfr-rapidozi-contact-utils";
import UniPair from "./UniPair";
import UniLink from "./UniLink";
import YourmapSlider from "./YourmapSlider";
import { MdOutlinePool } from "react-icons/md";
import { TbMassage } from "react-icons/tb";
import { TbParking } from "react-icons/tb";
import { GiHomeGarage } from "react-icons/gi";
import { IoFastFoodOutline } from "react-icons/io5";
import { FaWifi } from "react-icons/fa";
import { MdOutlineVilla } from "react-icons/md";
import { MdOutlineApartment } from "react-icons/md";
import { LuHotel } from "react-icons/lu";
import FrfrAlienGoogleMapsIframeBySrc from "./FrfrAlienGoogleMapsIframeBySrc";

// DEFAULT COMPONENT
const YourmapSectionSmestajStuff = (props) => {
  const {
    current_smestaj_entity,
  } = props.appPack;
  const item = current_smestaj_entity;
  const title = item.smestaj_naslov;
  _zzyourmap_routing_browser_title_update(title);

  // const img_url_full = _zzyourmap_extract_smestaj_main_img_url(item);
  const img_url_full = item._main_img_url;
  const slide_img_src_arr = item._slide_img_src_arr;

  /*
  const style = {
    // backgroundImage: 'url("https://ymdemo2.applabz.work/uploads/2025-11-30_img_692d2f80c5777.jpg")',
    backgroundImage: 'url("' + img_url_full + '")',
  };
  */

  // console.log('smestaj geo_uri', item.geo_uri);

  return (
    <>
      {/*
      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-05rem"></div>
          <div className="yourmap__card yourmap__card--big-cover">
            <div className="yourmap__card__overlay-1" style={style}></div>
            <div className="yourmap__card__overlay-2"></div>
            <div className="yourmap__card-destinacija-content">
              <div className="yourmap__article__title-and-subtitle">
                <div className="uu-gap-standalone-1rem"></div>
                <h1>{item.smestaj_naslov}</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-8px"></div>
          <div className="yourmap__slider__thumbnails">
            <div className="uu-vector uu-vector-row uu-vector--forced uu-gaps-p-025rem">
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      */}

      <YourmapSlider
        hero_title={item.smestaj_naslov}
        main_img_src={img_url_full}
        slide_img_src_arr={slide_img_src_arr}
      />

      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-16px"></div>
          <div className="yourmap__card yourmap__card--normal uu-shadow-alien-fluent2-tile-shadow">
            <h2>{item.smestaj_naslov}</h2>
            <p>{item.smestaj_podnaslov}</p>
          </div>
        </div>
      </section>

      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-16px"></div>
          <div className="yourmap__card yourmap__card--normal uu-shadow-alien-fluent2-tile-shadow">
            <h3>Opis smeštaja</h3>
            <p className="uu-text-justify">{item.smestaj_opis}</p>
            <div className="uu-gap-standalone-8px"></div>
            <p><i className="fa fa-map-marker" aria-hidden="true"></i>&nbsp;&nbsp;{item.smestaj_adresa}</p>
          </div>
        </div>
      </section>

      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-1rem"></div>
          <h3 className="yourmap__heading-above-card">Pogodnosti</h3>
          <div className="yourmap__grid yourmap__grid--items-w-1-5">
            {
              item.check_hotel === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><LuHotel /></div>}
                      jsx2={<span>Hotel</span>}
                    />
                  </div>
                </div>
              )
            }
            {
              item.check_apartman === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><MdOutlineApartment /></div>}
                      jsx2={<span>Apartman</span>}
                    />
                  </div>
                </div>
              )
            }
            {
              item.check_vila === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><MdOutlineVilla /></div>}
                      jsx2={<span>Vila</span>}
                    />
                  </div>
                </div>
              )
            }
            {
              item.check_bazen === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><MdOutlinePool /></div>}
                      jsx2={<span>Bazen</span>}
                    />
                  </div>
                </div>
              )
            }
            {
              item.check_spa === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><TbMassage /></div>}
                      jsx2={<span>Spa centar</span>}
                    />
                  </div>
                </div>
              )
            }
            {
              item.check_parking === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    {/*<div className="yourmap__card__pogodnost__icon"><i className="fa fa-car" aria-hidden="true"></i></div>*/}
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><TbParking /></div>}
                      jsx2={<span>Parking</span>}
                    />
                  </div>
                </div>
              )
            }
            {
              item.check_garaza === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><GiHomeGarage /></div>}
                      jsx2={<span>Garaža</span>}
                    />
                  </div>
                </div>
              )
            }
            {
              item.check_dorucak === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><IoFastFoodOutline /></div>}
                      jsx2={<span>Doručak</span>}
                    />
                  </div>
                </div>
              )
            }
            {
              item.check_wifi === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    {/*<div className="yourmap__card__pogodnost__icon"><i className="fa fa-wifi" aria-hidden="true"></i></div>*/}
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__pogodnost-pair"
                      jsx1={<div className="yourmap__card__pogodnost__icon"><FaWifi /></div>}
                      jsx2={<span>WiFi</span>}
                    />
                  </div>
                </div>
              )
            }
            {
              item.check_klima === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pogodnost uu-shadow-alien-fluent2-tile-shadow">
                    <div className="yourmap__card__pogodnost__icon"><i className="fa fa-snowflake-o" aria-hidden="true"></i></div>
                    <span>Klima</span>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </section>

      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-1rem"></div>
          <h3 className="yourmap__heading-above-card">Lokacija</h3>
          <div className="yourmap__card yourmap__card--normal uu-shadow-alien-fluent2-tile-shadow">

            <div className="yourmap__pair-map-and-contact">
              <div className="yourmap__pair-map-and-contact__map">
                {/*
                <FrfrAlienGoogleMapsIframe ll={ll} zoom={null} />
                <FrfrAlienOpenStreetMapIframe ll={ll} zoom={zoom} />
                */}
                <FrfrAlienGoogleMapsIframeBySrc
                  src={item.google_maps_iframe_src}
                  width="600"
                  height="240"
                />
                {/*
                */}
              </div>
              <div className="uu-gap-standalone-16px"></div>
              <div className="yourmap__pair-map-and-contact__contact contact-items">
                {
                  Easy69_v1.is_string_not_empty(item.telefon) && (
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__contact-pair"
                      jsx1={<div className="yourmap__contact__icon"><i className="fa fa-phone" aria-hidden="true"></i></div>}
                      jsx2={<UniLink
                        phone={rapidozi_contact_utils.fix_contact_phone_number(item.telefon)}
                      ><span>{item.telefon}</span></UniLink>}
                    />
                  )
                }
                {
                  Easy69_v1.is_string_not_empty(item.telefon2) && (
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__contact-pair"
                      jsx1={<div className="yourmap__contact__icon"><i className="fa fa-phone" aria-hidden="true"></i></div>}
                      jsx2={<UniLink
                        phone={rapidozi_contact_utils.fix_contact_phone_number(item.telefon2)}
                      ><span>{item.telefon2}</span></UniLink>}
                    />
                  )
                }
                {
                  Easy69_v1.is_string_not_empty(item.mobilni) && (
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__contact-pair"
                      jsx1={<div className="yourmap__contact__icon"><i className="fa fa-mobile" aria-hidden="true"></i></div>}
                      jsx2={<UniLink
                        phone={rapidozi_contact_utils.fix_contact_phone_number(item.mobilni)}
                      ><span>{item.mobilni}</span></UniLink>}
                    />
                  )
                }
                {
                  Easy69_v1.is_string_not_empty(item.mobilni2) && (
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__contact-pair"
                      jsx1={<div className="yourmap__contact__icon"><i className="fa fa-mobile" aria-hidden="true"></i></div>}
                      jsx2={<UniLink
                        phone={rapidozi_contact_utils.fix_contact_phone_number(item.mobilni2)}
                      ><span>{item.mobilni2}</span></UniLink>}
                    />
                  )
                }
                {
                  Easy69_v1.is_string_not_empty(item.email) && (
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__contact-pair"
                      jsx1={<div className="yourmap__contact__icon"><i className="fa fa-envelope-o" aria-hidden="true"></i></div>}
                      jsx2={<UniLink
                        email={item.email}
                      ><span>{item.email}</span></UniLink>}
                    />
                  )
                }
                {
                  Easy69_v1.is_string_not_empty(item.websajt) && (
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__contact-pair"
                      jsx1={<div className="yourmap__contact__icon"><i className="fa fa-link" aria-hidden="true"></i></div>}
                      jsx2={<UniLink
                        targetBlank
                        href={rapidozi_contact_utils.fix_contact_website_url(item.websajt)}
                      ><span>{item.websajt}</span></UniLink>}
                    />
                  )
                }
                {
                  Easy69_v1.is_string_not_empty(item.kontakt_instagram_url) && (
                    <UniPair
                      iconAndTitle
                      extraClass="yourmap__theme__contact-pair"
                      jsx1={<div className="yourmap__contact__icon"><i className="fa fa-instagram" aria-hidden="true"></i></div>}
                      jsx2={<UniLink
                        targetBlank
                        href={rapidozi_contact_utils.fix_contact_website_url(item.kontakt_instagram_url)}
                      ><span>{item.kontakt_instagram_url}</span></UniLink>}
                    />
                  )
                }
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default YourmapSectionSmestajStuff;